import * as Actions from "./actions";
import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { NOTIF_ERROR } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";


export const getPollList = (params) => (dispatch) => {
    return ApiService.list(Path.POLL_ROOT, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data.list));
            return response.data;
        })
        .catch((error) => {
            SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
        })
};

export const getPollResult = (id) => (dispatch) => {
    return ApiService.get(Path.POLL_ROOT + '/result/' + id)
        .then((response) => {
            dispatch(Actions.setPoll(response.data.data));
            return response.data;
        })
        .catch((error) => {
            SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR)
        })
};


export const insertPoll = (pollDetails, imageFile) => () => {
    const params = new FormData();
    pollDetails = Object.keys(pollDetails).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => { obj[key] = pollDetails[key]; return obj; }, {});
    params.append("pollDetails", JSON.stringify(pollDetails));
    params.append("imageFile", imageFile);
    return ApiService.insert(Path.POLL_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const updatePoll = (pollDetails, imageFile) => () => {
    const params = new FormData();
    pollDetails = Object.keys(pollDetails).filter(key => "startDate" !== key && "endDate" !== key).reduce((obj, key) => { obj[key] = pollDetails[key]; return obj; }, {});
    params.append("pollDetails", JSON.stringify(pollDetails));
    params.append("imageFile", imageFile);
    return ApiService.update(Path.POLL_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const insertPollSelection = (params) => (dispatch) => {
    return ApiService.post(Path.POLL_ROOT + `/insert/pollSelection`, params)
        .then((response) => {
            dispatch(getPollById(params.pollId))
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}


export const insertPollSelectionChoice = (params, pollId, imageFile) => (dispatch) => {

    const data = new FormData();
    data.append("pollSelectionChoiceDetails", JSON.stringify(params));
    data.append("imageFile", imageFile);
    return ApiService.post(Path.POLL_ROOT + `/insert/pollSelectionChoice`, data)
        .then((response) => {
            dispatch(getPollById(pollId))
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const updatePollSelectionChoice = (params, pollId, imageFile) => (dispatch) => {

    const data = new FormData();
    data.append("pollSelectionChoiceDetails", JSON.stringify(params));
    data.append("imageFile", imageFile);
    return ApiService.post(Path.POLL_ROOT + `/update/pollSelectionChoice`, data)
        .then((response) => {
            dispatch(getPollById(pollId))
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const updatePollAnnouncement = (pollId, pollAnnouncement) => (dispatch) => {

    const data = new FormData();
    data.append("pollAnnouncementResult", pollAnnouncement);
    data.append("pollId", pollId);
    return ApiService.post(Path.POLL_ROOT + `/update/pollAnnouncement/`, data)
        .then((response) => {

            dispatch(getPollResult(pollId))
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const deletePollSelectionChoice = (pollId, id) => (dispatch) => {
    return ApiService.deleteWithSlash(Path.POLL_ROOT + `/delete/${id}/pollSelectionChoice`)
        .then((response) => {
            dispatch(getPollById(pollId))
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const deletePollSelection = (pollId, id) => (dispatch) => {
    return ApiService.deleteWithSlash(Path.POLL_ROOT + `/delete/${id}/pollSelection`)
        .then((response) => {
            dispatch(getPollById(pollId))
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}


export const getPollById = (id) => (dispatch) => {
    return ApiService.get(Path.POLL_ROOT + `/${id}`)
        .then((response) => {
            dispatch(Actions.setPoll(response.data.data));
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deletePoll = (id) => () => {
    return ApiService.delete(Path.POLL_ROOT, id)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const insertPollManualVotes = (data, pollId) => (dispatch) => {
    return ApiService.post(Path.POLL_ROOT + `/insert/pollManualVotes`, data)
        .then((response) => {
            dispatch(getPollResult(pollId))
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const sendOnlineResult = (emailAddress, pollId) => () => {

    const data = new FormData();
    data.append("emailAddress", emailAddress);
    data.append("pollId", pollId);

    return ApiService.post(Path.POLL_ROOT + `/sendOnlineResult`, data)
        .then((response) => {
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}

export const sendFinalResult = (emailAddress, pollId) => () => {

    const data = new FormData();
    data.append("emailAddress", emailAddress);
    data.append("pollId", pollId);

    return ApiService.post(Path.POLL_ROOT + `/sendFinalResult`, data)
        .then((response) => {
            return response.data
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}



